/**
 * World positions for waiting-cat queue slots (thumb reach along bottom).
 */

import { BEDROOM_DEFAULT } from './bedroom.js';

export interface QueueSlotPosition {
  x: number;
  y: number;
}

/** Two Arcade queue slots above the bottom safe area. */
export function arcadeQueueSlots(): readonly QueueSlotPosition[] {
  const w = BEDROOM_DEFAULT.bedWidth;
  const h = BEDROOM_DEFAULT.playfieldHeight;
  return [
    { x: w * 0.28, y: h - 52 },
    { x: w * 0.72, y: h - 52 },
  ];
}

/** Hit radius for tapping a waiting cat. */
export const QUEUE_HIT_RADIUS = 36;
